export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <h3 className="font-heading text-2xl text-primary-400 mb-3">吃瓜爆料网</h3>
              <p className="text-sm text-background-300 leading-relaxed">
                吃瓜爆料网官方发布页，一站覆盖App下载、网站入口和最新地址。持续追踪博主反差视频与塌房现场，替代收藏夹里失效的老地址。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-background-100 mb-4 text-sm">快速导航</h4>
              <ul className="space-y-2.5">
                {[
                  { id: 'cards', label: '热门爆料' },
                  { id: 'ranking', label: '吃瓜热榜' },
                  { id: 'topics', label: '热门话题' },
                  { id: 'updates', label: '最新动态' },
                ].map((item) => (
                  <li key={item.id}>
                    <a
                      href={`#${item.id}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-background-100 mb-4 text-sm">平台入口</h4>
              <ul className="space-y-2.5">
                {[
                  { id: 'app', label: 'App下载' },
                  { id: 'faq', label: '常见问题' },
                  { id: 'features', label: '平台特色' },
                  { id: 'index', label: '主题索引' },
                ].map((item) => (
                  <li key={item.id}>
                    <a
                      href={`#${item.id}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-background-100 mb-4 text-sm">合作伙伴</h4>
              <p className="text-sm text-background-400">优质合作站点持续招募中</p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 吃瓜爆料网 — 本站为导航入口页，仅供信息参考
            </p>
            <p className="text-xs text-background-500">
              吃瓜爆料网app下载 · 吃瓜爆料网最新地址 · 吃瓜爆料网站入口
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}